import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

export const SidebarPaidPlacementContainer = styled.div<{ $stickyTop?: number | null }>`
  height: 100%;
  width: 100%;

  @media (${breakpoint.xlMin}) {
    margin-bottom: 24px;
  }
`;

export const SidebarPaidPlacementAd = styled.div<{ $stickyTop?: number | null }>`
  position: sticky;
  top: ${({ $stickyTop }) => ($stickyTop ? $stickyTop + 10 : 100)}px;
  
  @media (${breakpoint.xlMin}) {
    & .section-container,
    & .bottom-section {
      display: none;
    }

    & .content-wrapper > .button-mobile {
      display: none;
    }
  }
`;
